import { toast } from "react-toastify"
import { apiConstants } from "../apiConstant"
import { serviceCall } from "../serviceCall"
import compileErrors from "../compileErorrs"
import { setLoading } from "../../feature/authSlice"

export const getTotalInvoiceOverdueApi = (data, callback, errorCallBack) => {
  return async (dispatch) => {
    dispatch(setLoading(true))
    serviceCall({
      url: apiConstants.DASH.GET_TOTAL_INVOICEOVERDUE,
      method: 'get',
      data: data,
    })
      .then((response) => {
        dispatch(setLoading(false))
        callback && callback(response)
      })
      .catch((error) => {
        dispatch(setLoading(false))
        toast.error(compileErrors(error.response.data.error))
        errorCallBack && errorCallBack(error.response)
      })
  }
}
